import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import {
    PanelHeader,
    PanelBody,
    CloseButton,
    OverlayFormInput,
    PanelFooter,
    Button
} from 'components';
import { SlideUpPanel } from '../slideup-panel';

import './style.scss';

export interface IMobileUILinkWindowProps extends WithTranslation {
    link: string;
    onClose: () => any;
}
export interface IMobileUILinkWindowState {}

class MobileUILinkWindowComponent extends React.Component<IMobileUILinkWindowProps, IMobileUILinkWindowState> {
    input_el: HTMLInputElement = null;

    constructor(props: IMobileUILinkWindowProps) {
        super(props);
    }

    render() {
        let { t } = this.props;
        return (
            <SlideUpPanel
                open
                className='mobile-ui-link-window fix-close-button'
            >
                <PanelHeader>
                    <div className="header-text">
                        {t('Ссылка на объект')}
                    </div>
                    <CloseButton
                        onClick={() => {
                            this.props.onClose();
                        }}
                    />
                </PanelHeader>

                <PanelBody>
                    <OverlayFormInput
                        readOnly
                        value={this.props.link}
                        wrapperClassname='link-input'
                        variant='underlined'
                        onClick={(e) => {
                            e.currentTarget.setSelectionRange(0, 9999);
                            document.execCommand('copy');
                        }}
                        ref={(el) => { this.input_el = el; }}
                    />
                </PanelBody>

                <PanelFooter>
                    <Button
                        text={t('Закрыть')}
                        onClick={() => {
                            this.props.onClose();
                        }}
                    />
                </PanelFooter>
            </SlideUpPanel>
        );
    }
}

export const MobileUILinkWindow = withTranslation()(MobileUILinkWindowComponent);
